const initialState = {
  menus: [],
};

const MenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_MENUS_SUCCESS":
      return {
        ...state,
        menus: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default MenuReducer;
